import { render, staticRenderFns } from "./MembershipDetailsRoute.vue?vue&type=template&id=037be6ce&"
import script from "./MembershipDetailsRoute.vue?vue&type=script&lang=ts&"
export * from "./MembershipDetailsRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports